module.exports = __webpack_public_path__ + "img/71eb1d5.png";